import React, { ReactElement, useEffect } from 'react';
import { Button, ButtonGroup, Col, Dropdown, Row } from 'react-bootstrap';
import { BiNote, BiPlus } from 'react-icons/all';
import { useNavigate } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { CellProps } from 'react-table';
import { ModeleCourriel } from '../../../../../common/src/entities';
import { useDeleteEntite, useEntites } from '../../../Utils/api';
import { useAlertDialog } from '../../../Utils/dialogContext';
import PopoverSimple from '../../Common/PopoverSimple';
import EnteteDePage from '../Utils/EnteteDePage';
import TableSimple from '../Utils/TableSimple';
import { Colonne } from '../Utils/TypesTableSimple';

export default function ModelesCourriel(): ReactElement {
    const bsAlert = useAlertDialog();
    const navigate = useNavigate();
    const [supprimerModeleCourrielQuery] = useDeleteEntite(ModeleCourriel);
    const modelesCourriel = useEntites(ModeleCourriel);

    useEffect(() => {
        document.title = 'Modèles de courriel - Dashboard';
    }, []);

    const colonnes: Colonne<ModeleCourriel>[] = [
        {
          Header: 'Nom',
          accessor: 'name',
        },
        {
          Header: 'Titre',
          accessor: 'title',
        },
        {
          Header: 'Contenu',
          Cell: function CelluleBody({ value }: CellProps<ModeleCourriel>) {
              return value ? (
                  <PopoverSimple inList texte={value} titre="Contenu">
                      <BiNote />
                  </PopoverSimple>
              ) : null;
          },
          accessor: 'body',
          disableSortBy: true,
        },
    ];

    const deleteModeleCourriel = async (modele: ModeleCourriel) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce modèle de courriel?')) {
            try {
                await supprimerModeleCourrielQuery(modele.id);
            } catch (error) {
                const { response } = error;
                if (response?.status === 409) {
                    bsAlert(
                        "D'autres entités dépendent de ce modèle de courriel, impossible de le supprimer",
                        'warning',
                    );
                } else {
                    bsAlert(`Erreur dans la suppression du modèle: ${error.message}`, 'danger');
                }
            }
        }
    };

    return (
        <>
            <Row>
                <Col>
                    <EnteteDePage texte="Modèles de courriel" cacherBoutonRetour />
                </Col>
                <Col xs="auto">
                    <LinkContainer to="new">
                        <ButtonGroup>
                            <Button size="sm" variant="outline-primary" className="d-flex align-items-center">
                                <BiPlus /> Ajouter un modèle de courriel
                            </Button>
                        </ButtonGroup>
                    </LinkContainer>
                </Col>
            </Row>
            <TableSimple
                colonnes={colonnes}
                resultat={modelesCourriel}
                lien="id"
                hover
                affichageMenu={(modeleCourriel) => (
                    <>
                        <Dropdown.Item onClick={() => navigate(String(modeleCourriel.id))}>Modifier</Dropdown.Item>
                        <Dropdown.Item onClick={() => deleteModeleCourriel(modeleCourriel)} className="text-danger">
                            Supprimer
                        </Dropdown.Item>
                    </>
                )}
                etatInitial={{
                    sortBy: [
                        {
                            id: 'name',
                            desc: false,
                        },
                    ],
                }}
            />
        </>
    );
}
